import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-esqueci-minha-senha-enviar-email',
    templateUrl: './esqueci-minha-senha-enviar-email.component.html',
    styleUrls: ['./esqueci-minha-senha-enviar-email.component.css'],
    imports: [ReactiveFormsModule, FormsModule, CommonModule]
})
export class EsqueciMinhaSenhaEnviarEmailComponent implements OnInit {

  public form: FormGroup = null;
  public loading: boolean = false;

  public concluido: boolean = false;
  public msgErro: string = null;

  constructor(public autenticacao: AutenticacaoService, private router: Router, private route: ActivatedRoute) { 
    
    this.form = new FormGroup({
      cpf: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email])
    });

  }

  ngOnInit() {

  }

  enviar(){

    let cpf = this.form.get('cpf').value;
    let email = this.form.get('email').value;

    this.loading = true;
    this.form.disable();

    this.autenticacao
        .esqueciMinhaSenhaEnviarTokenEmail(cpf, email)
        .pipe(
          finalize(() => { 
            this.loading = false;
            this.form.enable();
          })
        )
        .subscribe(
          (res: any) => {

            this.concluido = true;
            this.msgErro = null;

          },
          (httpError: HttpErrorResponse) => {
            this.msgErro = httpError.error.ex;

            setTimeout(()=> {
              this.msgErro = null;
            }, 6000);
        });
  }


}
